import React from "react";

export const ARCHETYPES = {
  "NUMEROLOGY SCORER": { icon: "🔢", rule: "Numerology alignment + ≥1 positive scoring indicator", support: "🔢 Core Number · Direct Set · Day-Date · Universal · Planet · Hidden Number" },
  "DAY-TREND SCORER": { icon: "📅", rule: "Positive day-of-week trend + ≥1 positive scoring indicator", support: "📅 Day Trend · Historical G/A · Shooting % · SOG" },
  "GOAL SNIPER": { icon: "🔥", rule: "≥2 G + ≥5 SOG + ≥20% SH%", support: "🗺️ · ⚔️ · 🎯" },
  "SHOT VOLUME": { icon: "🎯", rule: "≥8 SOG + ≥2.5 SOG/GP", support: "7️⃣ · 🗺️ · 🎯" },
  "POWER FINISHER": { icon: "💥", rule: "≥2 G + ≥6 SOG + ≥18% SH%", support: "⚔️ · 🟢 · ⌛" },
  "BREAKOUT FINISHER": { icon: "🧨", rule: "≥2 G + ≥5 SOG + ≥25% SH%", support: "📈 · ⌛ · 💲" },
  "ELITE CREATOR": { icon: "⚡", rule: "≥5 PTS + ≥3 A + ≥17:00 TOI", support: "🧠 · 🎯 · 🗺️" },
  PLAYMAKER: { icon: "🧠", rule: "≥3 A + ≥4 PTS + A > G", support: "🅰️ · 📈" },
  "VOLUME WINGER": { icon: "🏹", rule: "LW/RW + ≥8 SOG + ≥2.0 SOG/GP", support: "7️⃣ · 🗺️ · ⚔️" },
  "NET-FRONT FINISHER": { icon: "🥅", rule: "≥2 G + ≥5 SOG + ≥18% SH%", support: "🏠 · ⚔️ · ⚡" },
  "OFFENSIVE DEFENSEMAN": { icon: "🛡️", rule: "D + ≥3 PTS + ≥18:00 TOI + ≥4 SOG", support: "🗺️ · 🎯 · ⚡" },
  "TRANSITION THREAT": { icon: "🚀", rule: "≥4 PTS + ≥17:00 TOI", support: "🎯 · 📈" },
  "HIGH-VARIANCE SCORER": { icon: "🎲", rule: "≥2 G + ≤8 SOG + ≥25% SH%", support: "⌛ · 💲 · 🪙" },
  "LOW-GOAL CREATOR": { icon: "❄️", rule: "≥4 PTS + ≤1 G + ≥3 A", support: "🅰️ · 🧠" },
  "SECONDARY OFFENSE": { icon: "👻", rule: "≥3 PTS + ≥5 SOG", support: "🎯 · 🗺️ · 📈" },
  "VOLUME WITHOUT FINISH": { icon: "⚠️", rule: "≥8 SOG + ≤1 G", support: "📈 · ⌛" },
};

export const ArchetypeBadge = ({ name, showSupport = false, testId }) => {
  const key = typeof name === "object" ? name?.primary : name;
  const m = ARCHETYPES[key];
  if (!m) return null;
  return (
    <span
      data-testid={testId || "archetype-badge"}
      title={`${key} · Last 5: ${m.rule}\n${m.support}`}
      className="inline-flex items-center gap-1 whitespace-nowrap rounded bg-fuchsia-950/60 px-1 font-mono text-[9px] font-semibold uppercase text-fuchsia-300"
    >
      <span>{m.icon}</span>{key}
      {showSupport && <span className="ml-1 normal-case text-fuchsia-400/70">{m.support}</span>}
    </span>
  );
};

export default ArchetypeBadge;
